<script setup lang="ts">
import type { AwardFormProps } from '@/types/appTypes'

const props = withDefaults(defineProps<AwardFormProps>(), {})

const app = useNuxtApp()

const refData = reactive({
  sending: false,
  errorMessage: null,
  innerFormData: {
    name: '',
    title: '',
    comment: '',
    password: '',
    recaptcha: '',
  },
  isValidForm: false,
})
const recaptcha = ref(null)

const onSubmit = async () => {
  if (!isPost()) {
    alert('投票は1日1回となります。')
    return
  }
  if (!refData.isValidForm) {
    return
  }
  await recaptcha.value.execute()
}

const onToken = async (token) => {
  refData.innerFormData.recaptcha = token
  refData.sending = true

  refData.innerFormData.password = 'Zz123123!' + Math.random().toString(32).substring(2)

  try {
    const res = await app.$ArticleApi.articleCommentAdd(
      props.slug,
      props.article,
      refData.innerFormData.name,
      refData.innerFormData.title,
      refData.innerFormData.comment,
      refData.innerFormData.password,
      refData.innerFormData.recaptcha,
    )
    refData.sending = false
    if (res.data?.code === 200000) {
      setDate()
      refData.errorMessage = null
      // todo: 戻ったときにキャッシュなしfetch
      if (props.article === 'museum-chara') {
        navigateTo({
          name: 'static-slug',
          params: { slug: 'vote-complete' },
        })
      } else {
        navigateTo({
          name: 'static-slug',
          params: { slug: 'vote-complete-eto' },
        })
      }
      return
    }
    refData.innerFormData.password = null
    refData.errorMessage = 'エラーが発生しました' + '(' + res.data.code + ')'
  } catch (e) {
    refData.innerFormData.password = null
    refData.errorMessage = 'エラーが発生しました'
  }
  refData.sending = false
}

const setDate = () => {
  const date = useDayjs().format('YYYY-MM-DD')
  if (props.article === 'museum-chara') {
    localStorage['im.chara.entry'] = date
  } else if (props.article === 'eto-colle') {
    localStorage['im.eto.entry'] = date
  }
}

const isPost = () => {
  if (import.meta.client) {
    let date
    if (props.article === 'museum-chara') {
      date = localStorage['im.chara.entry']
    } else if (props.article === 'eto-colle') {
      date = localStorage['im.eto.entry']
    }
    if (date) {
      if (!useDayjs().isAfter(useDayjs(date), 'day')) {
        return false
      }
    }
    return true
  } else {
    return false
  }
}

refData.errorMessage = null
</script>

<template>
  <div class="p-form">
    <template
      v-if="isPost()"
    >
      <div class="c-heading_error">
        <template
          v-if="refData.errorMessage"
        >
          {{ refData.errorMessage }}
        </template>
      </div>
      <v-form
        ref="vform"
        v-model="refData.isValidForm"
      >
        <div class="p-form_controls">
          <div class="p-form_inputBlock">
            <div class="p-form_inputBlock_labelRow">
              <div class="p-form_inputBlock_labelRow_text">
                応援メッセージ
              </div>
            </div>

            <v-textarea
              v-model="refData.innerFormData.comment"
              name="コメント"
              variant="outlined"
              v-bind:rules="[(value) => app.$vvMax(value, 200)]"
              counter="200"
              maxlength="200"
            />
          </div>

          <Recaptcha
            id="recaptcha"
            ref="recaptcha"
            v-on:token="onToken"
          />

          <div
            class="p-form_action"
          >
            <v-btn
              class="c-btn_formSubmit"
              v-bind:disabled="!refData.isValidForm || !isPost()"
              color="primary"
              v-on:click="onSubmit"
            >
              <v-icon>mdi-file-document-edit-outline</v-icon>
              この作品に投票する
            </v-btn>
          </div>
        </div>
      </v-form>
    </template>
    <template
      v-else
    >
      <p class="p-museumChar_info">
        投票は1日1回までとなります。
      </p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.p-form {
  padding-top: 0;
}
</style>
